import {Box, Fade, Chip} from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import React from "react";

export function RunWithFeedback({
  showStartedFeedback,
  bottom = false,
  children,
}) {
  return (
    <Box display="flex" justifyContent="flex-end" alignItems="center">
      <Box
        style={{
          position: "relative",
          display: "inline-block",
        }}
      >
        {children}
        <Fade in={showStartedFeedback}>
          <Chip
            icon={<CheckCircleIcon style={{color: "#4caf50"}} />}
            label="Run started"
            style={{
              position: "absolute",
              left: "50%",
              ...(bottom ? {bottom: "-30px"} : {top: "-30px"}),
              transform: "translateX(-50%)",
              backgroundColor: "#e8f5e8",
              color: "#2e7d2e",
              border: "1px solid #c8e6c9",
              fontWeight: 500,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              zIndex: 1000,
              whiteSpace: "nowrap",
            }}
            size="small"
          />
        </Fade>
      </Box>
    </Box>
  );
}
